import cx from 'classnames';
import dynamic from 'next/dynamic';

import styles from './index.module.scss';

const Typography = dynamic(import('#app/UI/atoms/new-typography'));
const IconStar = dynamic(import('./icons').then(module => module.IconStar));

const list = [
  {
    stars: 5,
    name: 'David Acosta',
    extra: 10,
    description:
      '“En la ruta de Super Programador he aprendido sobre temas que nunca creí conocer como JavaScript y Python. Además, hice amigos con los mismos intereses que los míos. ¡Estoy muy feliz!”',
    country: 'Colombia'
  },
  {
    stars: 5,
    name: 'Mamá de Sophia',
    extra: 11,
    description:
      '“Crack The Code es una academia de cursos creativos, tecnológicos e innovadores para niños del futuro. ¡Mi hija está encantada con el entusiasmo de sus profesores!”',
    country: 'Perú'
  },
  {
    stars: 5,
    name: 'Simón Gómez',
    extra: 7,
    description:
      '“Soy Simón y soy también un creador de tecnología. Hoy creé una animación en mi curso de animación digital. Aprendí a hacer secuencias para mover a mis personas.¡Programar me gusta mucho!”',
    country: 'México'
  }
];

const Card = ({
 stars, name, extra, description, country 
}) => (
  <li className={styles.card}>
    <div className="flex gap-x-4 mb-16">
      {Array.from({ length: stars }).map((_, idx) => (
        <IconStar key={idx} />
      ))}
    </div>

    <Typography className="typo-24 rockone mb-4" tag="p" style={{ color: '#047DEC' }}>
      {name}
    </Typography>
    <Typography className="typo-20 rockone mb-16" tag="p">
      {extra} {!isNaN(parseInt(extra)) && `año${extra > 1 && 's'}`}
    </Typography>
    <Typography className="typo-16 mb-24" tag="p">
      {description}
    </Typography>
    <Typography className="typo-20 rockone" tag="p">
      {country}
    </Typography>
  </li>
);

const Testimonials = ({ className }) => {
  return (
    <section className={styles.wrapper}>
      <div className={cx(className, styles.container)}>
        <ul className={cx(styles.list, 'gap-x-24 sm_px-20')}>
          {list.map((item, idx) => (
            <Card key={idx} {...item} />
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Testimonials;
